import * as constants from './../constants';
import * as actions from '../actions';
import { EndCallReasons } from './../../../common/services/doxy-analytics/tracks/video-session-end';
import { store } from './../../../store/store';
import { commonFlow } from './common-flow';
import { restartCall } from '../../call/actions';
export const providerFlow = {
    ...commonFlow,
    [constants.TroubleshootingStepName.VideoRefreshed]: {
        textItems: [
            { text: 'troubleshooting.wizard.refreshVideoResultsDescription' },
        ],
        actions: {
            primary: {
                text: 'troubleshooting.wizard.yesButton',
                onClick: async () => {
                    store.dispatch(actions.setStepName(constants.TroubleshootingStepName.ProblemResolved));
                    store.dispatch(actions.autoCloseInSeconds(constants.DELAY_ON_RESOLVED));
                },
            },
            secondary: {
                text: 'troubleshooting.wizard.noButton',
                onClick: async () => {
                    store.dispatch(actions.setStepName(constants.TroubleshootingStepName.RestartTheCall));
                },
            },
        },
    },
    [constants.TroubleshootingStepName.RestartTheCall]: {
        textItems: [
            { text: 'troubleshooting.wizard.refreshDidNotHelpDescription' },
        ],
        actions: {
            primary: {
                text: 'troubleshooting.wizard.restartCallButton',
                onClick: async () => {
                    store.dispatch(restartCall(EndCallReasons.RESTART_FROM_TROUBLESHOOTING));
                    store.dispatch(actions.setStepName(constants.TroubleshootingStepName.CallRestarted));
                },
            },
        },
    },
    [constants.TroubleshootingStepName.CallRestarted]: {
        textItems: [
            { text: 'troubleshooting.wizard.restartCallResultDescription' },
        ],
        actions: {
            primary: {
                text: 'troubleshooting.wizard.yesButton',
                onClick: async () => {
                    store.dispatch(actions.setStepName(constants.TroubleshootingStepName.ProblemResolved));
                    store.dispatch(actions.autoCloseInSeconds(constants.DELAY_ON_RESOLVED));
                },
            },
            secondary: {
                text: 'troubleshooting.wizard.noButton',
                onClick: async () => {
                    store.dispatch(actions.setStepName(constants.TroubleshootingStepName.NothingHelped));
                    store.dispatch(actions.autoCloseInSeconds(constants.DELAY_ON_NOT_RESOLVED));
                },
            },
        },
    },
};
